import React from 'react'
import { Modal } from 'react-bootstrap-v5'

type Props = {
  show: boolean
  onHide: () => void
  icon: React.ReactNode
  iconBg?: string
  iconBorderColor?: string
  title: React.ReactNode
  countValue: React.ReactNode
  countLabel: React.ReactNode
  description: React.ReactNode
  primaryLabel: React.ReactNode
  onPrimaryClick: () => void
  secondaryLabel: React.ReactNode
  onSecondaryClick: () => void
}

export const CountdownReminderModal = ({
  show,
  onHide,
  icon,
  iconBg = '#fff8e0',
  iconBorderColor = '#FFC20F',
  title,
  countValue,
  countLabel,
  description,
  primaryLabel,
  onPrimaryClick,
  secondaryLabel,
  onSecondaryClick,
}: Props) => (
  <Modal show={show} onHide={onHide} centered contentClassName="rounded-4">
    <Modal.Body className="text-center" style={{ padding: '36px 32px' }}>
      <div
        className="d-flex align-items-center justify-content-center rounded-circle mx-auto"
        style={{ width: 72, height: 72, background: iconBg, border: `2px solid ${iconBorderColor}`, fontSize: 30 }}
      >
        {icon}
      </div>
      <div className="fw-boldest" style={{ color: '#00171F', fontSize: 20, marginTop: 18 }}>
        {title}
      </div>
      <div className="fw-boldest" style={{ color: '#00171F', fontSize: 44, lineHeight: 1, marginTop: 20 }}>
        {countValue}
      </div>
      <div className="fw-boldest" style={{ color: '#00171F', fontSize: 13, marginTop: 4 }}>
        {countLabel}
      </div>
      <div style={{ color: '#6b7a83', fontSize: '13.5px', lineHeight: 1.7, marginTop: 16, maxWidth: 380 }} className="mx-auto">
        {description}
      </div>
      <div className="d-flex justify-content-center gap-3" style={{ marginTop: 26 }}>
        <button
          type="button"
          onClick={onSecondaryClick}
          className="fw-boldest"
          style={{ background: '#fff', border: '1.5px solid #dfe3e6', color: '#4a5a63', borderRadius: 8, padding: '11px 20px', fontSize: '13.5px', cursor: 'pointer' }}
        >
          {secondaryLabel}
        </button>
        <button
          type="button"
          onClick={onPrimaryClick}
          className="fw-boldest"
          style={{ background: '#00171F', border: 'none', color: '#fff', borderRadius: 8, padding: '11px 20px', fontSize: '13.5px', cursor: 'pointer' }}
        >
          {primaryLabel}
        </button>
      </div>
    </Modal.Body>
  </Modal>
)

export default CountdownReminderModal
